import {
  GET_PAYRATE,
  GET_PAYRATE_SUCCESS,
  GET_PAYRATE_FAIL,
  DELETE_PAYRATE,
  DELETE_PAYRATE_SUCCESS,
  DELETE_PAYRATE_FAIL,
  UPDATE_PAYRATE,
  UPDATE_PAYRATE_SUCCESS,
  UPDATE_PAYRATE_FAIL,
  ADD_NEW_PAYRATE,
  ADD_PAYRATE_SUCCESS,
  ADD_PAYRATE_FAIL,
  PAYRATE_LOADING,
  PAYRATE_RESET
} from "./actionType";

export const resetPayrateState = (actionType) => ({
  type: PAYRATE_RESET,
  payload: { actionType },
});

export const getPayrateSuccess = (actionType, data) => ({
  type: GET_PAYRATE_SUCCESS,
  payload: { actionType, data },
});

export const getPayrateFail = (actionType, error) => ({
  type: GET_PAYRATE_FAIL,
  payload: { actionType, error },
});

export const getPayrate = data => ({
  type: GET_PAYRATE,
  payload: data,
});

export const getPayrateLoading = () => ({
  type: PAYRATE_LOADING
});

export const deletePayrate = data => ({
  type: DELETE_PAYRATE,
  payload: data,
});

export const deletePayrateSuccess = data => ({
  type: DELETE_PAYRATE_SUCCESS,
  payload: data,
});

export const deletePayrateFail = error => ({
  type: DELETE_PAYRATE_FAIL,
  payload: error,
});

export const updatePayrate = data => ({
  type: UPDATE_PAYRATE,
  payload: data,
});

export const updatePayrateFail = error => ({
  type: UPDATE_PAYRATE_FAIL,
  payload: error,
});

export const updatePayrateSuccess = data => ({
  type: UPDATE_PAYRATE_SUCCESS,
  payload: data,
});

export const addNewPayrate = data => ({
  type: ADD_NEW_PAYRATE,
  payload: data,
});

export const addPayrateSuccess = data => ({
  type: ADD_PAYRATE_SUCCESS,
  payload: data,
});

export const addPayrateFail = error => ({
  type: ADD_PAYRATE_FAIL,
  payload: error,
});